// @flow

import { cmsAxios } from '../axios-config';

const getInbox = (searchQuery, page) => {
  const url = `/support-chat/conversations?page=${page}${searchQuery ? `&_q=${searchQuery}` : ''}`;
  return cmsAxios.get(url);
};

export default getInbox;
